<template>
  <div class="AddSuperBom">
    <md-dialog-prompt
        :md-active.sync="active"
        v-model="versionName"
        md-title="What's version's name?"
        md-input-maxlength="30"
        md-input-placeholder="Type version's name..."
        md-confirm-text="Add"/>

    <md-button class="md-icon-button md-dense md-primary" @click="active = true">
      <md-icon>add_circle</md-icon>
    </md-button>
  </div>
</template>

<script>
export default {
  name: 'AddSuperBom',
  computed: {
    versionName: {
      get () {
        return this.$store.state.versionName
      },
      set (value) {
        if (value) {
          this.$store.dispatch('addSuperBom', value)
        }
      }
    }
  },
  data() {
    return {
      active: false,
    }
  }
}
</script>
